import React, { CSSProperties } from 'react';
import { usePreview } from 'react-dnd-preview';
import {useTypedSelector} from "../../hooks/useTypedSelector";
import Card from "../card/Card";

type DragItem = {
    card: any;
};

const CardDndPreview = () => {
    const { touchDragCoords } = useTypedSelector(state => state.game);

    const preview = usePreview<DragItem>();

    if (!preview.display) {
        return null;
    }

    const { item, ref, style } = preview;

    const x = Math.round(touchDragCoords.x);
    const y = Math.round(touchDragCoords.y);

    const styleMod: CSSProperties = {
        ...(style as CSSProperties),
        transform: '',
        WebkitTransform: '',
        position: 'fixed',
        left: `${x}px`,
        top: `${y}px`,
        pointerEvents: 'none',
        zIndex: 9999,
    };

    return (
        <div
            className="dndPreview"
            ref={ref as React.Ref<HTMLDivElement>}
            style={styleMod}
        >
            <Card card={item.card} isSmall={true} isHand={true} />
        </div>
    );
};

export default CardDndPreview;